export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_ANALYTICS_ID;

export const pageview = (url: string): void => {
  if (window && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

export const conversion = (conversionLabel: string): void => {
  if (window && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: `${GA_TRACKING_ID}/${conversionLabel}`,
    });
  }
};
